import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../api/apiInterceptor";
import {displayNotification} from "./notification";

export const getNotes = createAsyncThunk(
    "getNotes",
    async ({installationId, locationId,page=0}) => {
        const result = await api.get(`/api/installations/${installationId}/locations/${locationId}/notes?page=${page}`);
        return result.data;
    }
)
export const createNote = createAsyncThunk(
    "createNote",
    async ({installationId, locationId, data}, {dispatch}) => {
        const result = await api.post(`/api/installations/${installationId}/locations/${locationId}/notes`, data);
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Bilješka uspješno kreirana!",
            title: "Kreiranje bilješke!"
        }));
        dispatch(getNotes({installationId, locationId}))
    }
)
export const updateNote = createAsyncThunk(
    "updateNote",
    async ({installationId, locationId, noteId, data}, {dispatch}) => {
        try {
            const result = await api.put(`/api/installations/${installationId}/locations/${locationId}/notes/${noteId}`, data);
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Bilješka uspješno ažurirana!",
                title: "Ažuriranje bilješke!"
            }));
            dispatch(getNotes({installationId, locationId}))
        } catch (err) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Ažuriranje nije dozvoljeno!",
                title: "Ažuriranje bilješke!"
            }));
        }

    }
)
export const deleteNote = createAsyncThunk(
    "deleteNote",
    async ({installationId, locationId, noteId},{dispatch}) => {
        await api.delete(`/api/installations/${installationId}/locations/${locationId}/notes/${noteId}`);
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Bilješka uspješno obrisana!",
            title: "Brisanje bilješke!"
        }));
        dispatch(getNotes({installationId, locationId}))
    }
)
const notesSlice = createSlice({
    name: "notes",
    initialState: {
        notesArray: [],
        loading: false,
        pagination: {
            currentPage: 1,
            total: 0,
            pageSize: 0,
        },
        showModal: false,
        showDeleteModal:false,
    },
    reducers: {
        setModalStatus: (state, action) => {
            state.showModal = action.payload;
        },
        setDeleteModalStatus:(state,action)=>{
            state.showDeleteModal = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getNotes.pending, state => {
                state.loading = true;
            })
            .addCase(getNotes.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.notesArray = content;
                state.pagination.total = totalElements;
                state.pagination.pageSize = size;
                state.pagination.currentPage = number;
                state.loading = false;
            })
            .addCase(getNotes.rejected, state => {
                state.notesArray = [];
                state.loading = false;
            })
            .addCase(deleteNote.fulfilled,state=>{
                state.showDeleteModal = false;
            })
    }
});
export const {setModalStatus,setDeleteModalStatus} = notesSlice.actions;
export default notesSlice.reducer;
